import { z } from 'zod';

/**
 * A company's name, address and phone, as setup asks for them: the old
 * Review Profile step and the new shell's Business profile sheet share it.
 * The address is optional, and free text or whatever Places filled in.
 */
export const businessProfileSchema = z.object({
  name: z.string().trim().min(1, 'Enter your business name.'),
  companyPhone: z.string().trim().min(1, 'Enter a phone number.'),
  addressLine: z.string(),
});

export type BusinessProfileValues = z.infer<typeof businessProfileSchema>;
